/**
 * Copyright (C) BoostCommerce.net
 * This file is part of commercial BoostCommerce.net projects
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * Created on Tue Feb 14 2023 22:28:29
 */

// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { FormLayout, TextStyle, Link, Icon, RangeSlider } from '@shopify/polaris';
import { ExternalMinor } from '@shopify/polaris-icons';
// import { Field } from 'redux-form';
// import { RenderSelect2 } from 'src/components/views/common/forms/render-select-2-v2';

import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { URL } from 'src/constants/links';
// import { PRODUCT_ITEM_BORDER_LAYOUT_OPTIONS } from 'src/constants/theme-settings';
import { MENU_ID } from 'src/constants/theme-settings.jsx';
// import { DropdownIndicator, styles } from './react-select-style';

type Props = {
  formValues: any,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ProductListLayoutForm extends Component<ComposedProps> {
  state = {};

  render() {
    const { i18n, updateField, formValues } = this.props;

    const productsPerPage = _.get(formValues, `setting.${MENU_ID.PRODUCT_LIST}.productsPerPage`, 2);
    const productsPerRowOnDesktop = _.get(
      formValues,
      `setting.${MENU_ID.PRODUCT_LIST}.productsPerRowOnDesktop`,
      2
    );
    const productsPerRowOnMobile = _.get(
      formValues,
      `setting.${MENU_ID.PRODUCT_LIST}.productsPerRowOnMobile`,
      1
    );
    // const formattedBorderLayoutSelect = PRODUCT_ITEM_BORDER_LAYOUT_OPTIONS.map(function (option) {
    //   return {
    //     ...option,
    //     label: i18n.translate(option.label)
    //   };
    // });
    return (
      <FormLayout>
        <div>
          <span className="form-link">
            <TextStyle variation="subdued">
              {i18n.translate('AdminHTML.ThemeSetting.Form.productList_UserGuide')}
            </TextStyle>{' '}
            <Link url={URL['ProductListLayoutShopifyIntegration']} external>
              {i18n.translate('AdminHTML.ThemeSetting.Common.clickHere')}
              <Icon source={ExternalMinor} color="base" />
            </Link>
            <span style={{ color: '#2C6ECB' }}>.</span>
          </span>
        </div>

        <div className="form-section">
          <div className="form-section__item form-section__item--medium-spacing">
            <RangeSlider
              label={i18n.translate('AdminHTML.ThemeSetting.Form.productList_ProductPerPage_Label')}
              value={productsPerPage}
              onChange={value =>
                updateField(`setting.${MENU_ID.PRODUCT_LIST}.productsPerPage`, value)
              }
              suffix={<p style={{ minWidth: '18px', textAlign: 'right' }}>{productsPerPage}</p>}
              min={2}
              max={50}
            />
          </div>
          <div className="form-section__item form-section__item--medium-spacing">
            <RangeSlider
              label={i18n.translate(
                'AdminHTML.ThemeSetting.Form.productList_ProductPerRowDesktop_Label'
              )}
              value={productsPerRowOnDesktop}
              onChange={value =>
                updateField(`setting.${MENU_ID.PRODUCT_LIST}.productsPerRowOnDesktop`, value)
              }
              suffix={
                <p style={{ minWidth: '18px', textAlign: 'right' }}>{productsPerRowOnDesktop}</p>
              }
              min={2}
              max={6}
            />
          </div>
          <div className="form-section__item form-section__item--medium-spacing">
            <RangeSlider
              label={i18n.translate(
                'AdminHTML.ThemeSetting.Form.productList_ProductPerRowMobile_Label'
              )}
              value={productsPerRowOnMobile}
              onChange={value =>
                updateField(`setting.${MENU_ID.PRODUCT_LIST}.productsPerRowOnMobile`, value)
              }
              suffix={
                <p style={{ minWidth: '18px', textAlign: 'right' }}>{productsPerRowOnMobile}</p>
              }
              min={1}
              max={2}
            />
          </div>

          {/* <div className="form-section__item form-section__item--medium-spacing">
            <Field
              name={`setting.${MENU_ID.PRODUCT_ITEM}.borderLayout`}
              label={i18n.translate('AdminHTML.ThemeSetting.Form.productItem_BorderLayout_Title')}
              options={formattedBorderLayoutSelect}
              component={RenderSelect2}
              components={{ DropdownIndicator }}
              styles={styles}
              isSearchable={false}
            />
          </div> */}
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(ProductListLayoutForm);
